import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from '@/services/axios';
import wx from 'weixin-sdk-js';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/guangzhou'
  },
  {
    path: '/chengdu',
    name: 'chengdu',
    meta: {
      keepAlive: false,
      auth: true
    },
    component: () => import(/* webpackChunkName: "chengdu" */ 'views/Salon/Chengdu.vue')
  },
  {
    path: '/shanghai',
    name: 'shanghai',
    meta: {
      keepAlive: false,
      auth: true
    },
    component: () => import(/* webpackChunkName: "shanghai" */ 'views/Salon/ShangHai.vue')
  },
  {
    path: '/guangzhou',
    name: 'guangzhou',
    meta: {
      keepAlive: false,
      auth: true
    },
    component: () => import(/* webpackChunkName: "guangzhou" */ 'views/Salon/Guangzhou.vue')
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
